import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Props as AmountWithConversionProps } from '@sorare/core/src/components/buyActions/AmountWithConversion';
import { AmountWithConversion } from '@sorare/core/src/components/buyActions/AmountWithConversion';
import { useStoreAmount } from '@sorare/core/src/hooks/useStoreAmount';
import { monetaryAmountFragment } from '@sorare/core/src/lib/monetaryAmount';

import type { PrimaryOfferPrice_primaryOffer } from './__generated__/index.graphql.ts';

type Props = {
  primaryOffer: PrimaryOfferPrice_primaryOffer;
} & Omit<
  AmountWithConversionProps,
  'monetaryAmount' | 'actualMain' | 'actualExponent'
>;

export const PrimaryOfferPrice = ({ primaryOffer, ...props }: Props) => {
  const { storeMain, storeExponent } = useStoreAmount(primaryOffer);

  if (!primaryOffer.price) return null;

  return (
    <AmountWithConversion
      monetaryAmount={primaryOffer.price}
      actualMain={storeMain}
      actualExponent={storeExponent}
      {...props}
      hideExponent={false}
    />
  );
};

PrimaryOfferPrice.fragments = {
  primaryOffer: gql`
    fragment PrimaryOfferPrice_primaryOffer on TokenPrimaryOffer {
      id
      price {
        ...MonetaryAmountFragment_monetaryAmount
      }
      ...useStoreAmount_primaryOffer
    }
    ${monetaryAmountFragment}
    ${useStoreAmount.fragments.primaryOffer}
  ` as TypedDocumentNode<PrimaryOfferPrice_primaryOffer>,
};
